async function c(e, o, n = "image/png") {
  const t = new OffscreenCanvas(e.width, e.height), a = t.getContext("2d");
  if (!a) throw new Error("Canvas context is not available");
  a.drawImage(e, 0, 0);
  const r = await t.convertToBlob({ type: n });
  return new File([r], o, { type: n });
}
export {
  c as imageToFile
};
